import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Paperclip = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M12.0385955,5.91792877 C13.7076303,4.24889397 16.4131597,4.24889397 18.0814046,5.91792877 C19.7097312,7.54625541 19.7494465,10.1611325 18.2005504,11.8368501 L18.0814046,11.9607379 L11.9607379,18.0814046 C10.2917031,19.7504394 7.58617366,19.7504394 5.91792877,18.0814046 C4.28960214,16.4530779 4.24988685,13.8382008 5.79878292,12.1624833 L5.91792877,12.0385955 L9.23326213,8.72326213 C10.1976117,7.75891259 11.7617217,7.75891259 12.7260712,8.72326213 C13.6571673,9.65435823 13.6892741,11.1445652 12.8224341,12.114178 L12.7261186,12.2160238 L9.4114519,15.5313571 C9.15112855,15.7917328 8.72901857,15.7917753 8.46864286,15.5314519 C8.22829605,15.2911535 8.20977167,14.9130013 8.4130953,14.6514534 L8.46854806,14.5886429 L11.7832621,11.2732621 C12.2269126,10.8296117 12.2269126,10.1097216 11.7832621,9.66607117 C11.3657088,9.24851778 10.7034587,9.22395582 10.2571175,9.59238528 L10.1760712,9.66607117 L6.86062623,12.9815161 C5.71243927,14.1291597 5.71243927,15.990297 6.86084938,17.1387071 C7.97147219,18.2498558 9.75029933,18.2856993 10.9046257,17.2461365 L11.0179288,17.1385955 L17.1387071,11.0178172 C18.2868941,9.87017368 18.2868941,8.00903637 17.1384839,6.86062623 C15.9908404,5.71243927 14.1297031,5.71243927 12.9814045,6.86073782 C12.721055,7.12108735 12.298945,7.12108735 12.0385955,6.86073782 C11.7782459,6.60038829 11.7782459,6.1782783 12.0385955,5.91792877 Z"
        id="path-1-paperclip"
      ></path>
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&amp;solid"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/email/paperclip/line">
        <mask id="mask-2-paperclip" fill="white">
          <use xlinkHref="#path-1-paperclip"></use>
        </mask>
        <use
          id="Atom/icon/paperclip"
          fill="#FFFFFF"
          fillRule="nonzero"
          xlinkHref="#path-1-paperclip"
        ></use>
        <g
          id="Group"
          mask="url(#mask-2-paperclip)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="🎨-color">
            <rect id="Rectangle" x="0" y="0" width="24" height="24"></rect>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
